/**
 * YazioDashboardPage - Router wrapper for Yazio Dashboard
 * Provides data and renders the dashboard content
 */

import React from "react";

import { useYazioDailyCalories } from "../../hooks/use-yazio-daily-calories";
import { YazioDashboard } from "../organisms/yazio-dashboard";

export const YazioDashboardPage: React.FC = () => {
  const dashboardData = useYazioDailyCalories();

  return (
    <YazioDashboard
      data={dashboardData.data ?? null}
      error={dashboardData.error ?? null}
      isLoading={dashboardData.isLoading}
      onClearError={dashboardData.clearError}
      onRefresh={dashboardData.loadTodayData}
    />
  );
};
